import {
  GetIngestionDocumentFragment,
  InternalGetIngestionDocumentFragment,
} from '@client/graphql/__generated__/types';

/**
 * Creates a mapping from field keys to user-friendly labels
 */
export function createFieldKeyToLabelMapping(
  document?:
    | GetIngestionDocumentFragment
    | InternalGetIngestionDocumentFragment
    | null
): Record<string, string> {
  const mapping: Record<string, string> = {};

  if (!document?.contractDocuments) {
    return mapping;
  }

  document.contractDocuments.forEach((contractDoc) => {
    const documentVersion = contractDoc.documentVersion;
    if (documentVersion?.documentVersionFields) {
      documentVersion.documentVersionFields.forEach((docVersionField) => {
        const field = docVersionField.field;
        if (field?.mappingKey) {
          const label = field.label || field.mappingKey;
          mapping[field.mappingKey] = label;
        }
      });
    }
  });

  return mapping;
}
